import couponAPI from '../../api/Coupon'
import * as types from '../mutation-types'

// STATE
const state = {
    Coupon: {},
    CouponOptions: []
}

// GETTERS
const getters = {
    CouponOptions: state => state.CouponOptions,
    Coupon: state => state.Coupon
}

// ACTIONS
const actions = {
    getCouponOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            couponAPI.getCouponOptions(couponOptions => {
                commit(types.RECEIVE_COUPON_OPTIONS, { couponOptions })
                resolve()
            }, params)
        })
    },
    getCoupon({ commit }, id) {
        return new Promise((resolve, reject) => {
            couponAPI.getCoupon(coupon => {
                commit(types.RECEIVE_COUPON, { coupon })
                resolve()
            }, id)
        })
    },
    createCoupon({ commit }, params) {
        return new Promise((resolve, reject) => {
            couponAPI.createCoupon(coupon => {
                resolve(coupon)
            }, params)
        })
    },
    updateCoupon({ commit }, params) {
        return new Promise((resolve, reject) => {
            couponAPI.updateCoupon(coupon => {
                resolve(coupon)
            }, params)
        })
    },
    submitCouponCode({ commit }, params) {
        return new Promise((resolve, reject) =>  {
            couponAPI.submitCouponCode(coupon => {
                resolve(coupon)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_COUPON_OPTIONS] (state, { couponOptions }) {
        state.CouponOptions = couponOptions
    },
    [types.RECEIVE_COUPON] (state, { coupon }) {        
        state.Coupon = coupon
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Coupon.js